module.exports = __webpack_public_path__ + "img/task-number.928c8026.svg";